import { createAsyncThunk } from '@reduxjs/toolkit';
import { addCategoryAPI, deleteCategoryByIdAPI, fetchCategoryAPI, updateCategoryByIdAPI } from './categoryAPI';

// Adding Category
export const addCategory = createAsyncThunk('category/addCategory', async (body, { rejectWithValue }) => {
  try {
    const response = await addCategoryAPI(body);
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

//Fetching Category
export const fetchCategory = createAsyncThunk('category/fetchCategory', async (_ , { rejectWithValue }) => {
  try{
    const response = await fetchCategoryAPI()
    return response
  }catch(error){
    return rejectWithValue(error)
  }
})

// Delete Category by id
export const deleteCategoryById = createAsyncThunk('category/deleteCategoryById', async (id, { rejectWithValue }) => {
  try{    
    const response = await deleteCategoryByIdAPI(id)
    return response
  }catch(error){
    return rejectWithValue(error)
  }
})

// update Category by id
export const updateCategoryById = createAsyncThunk("category/updateCategoryById", async ( body, { rejectWithValue }) => {
  try{
    const response = await updateCategoryByIdAPI(body)
    return response
  }catch(error){
    return rejectWithValue(error)
  }
})